import { type LocationSearchMachineAction } from '../types';
import { locationSearchLogger } from './logger';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Creates a no-op action that logs when an externally-provided action is
 * missing. The real implementation is supplied via `machine.provide(...)`
 * when initializing the machine.
 */
export function createPlaceholderAction<ActionParams = void>(
  actionName: string,
): LocationSearchMachineAction<ActionParams> {
  return () => {
    locationSearchLogger.debug(`\`${actionName}\` action is not provided.`);
  };
}

/**
 * Creates a no-op action that logs an error when an externally-provided
 * action is missing. Used for optional error handlers.
 */
export function createPlaceholderErrorAction(
  actionName: string,
  errorMessage: string,
): LocationSearchMachineAction {
  return () => {
    locationSearchLogger.error(
      `${errorMessage} (NOTE: Provide "${actionName}" action while setting up the machine to handle this error externally.)`,
    );
  };
}

/**
 * Creates a guard that logs when an externally-provided guard is missing and
 * resolves to `false`. The real implementation is supplied via
 * `machine.provide(...)` when initializing the machine.
 */
export function createPlaceholderGuard(guardName: string) {
  return () => {
    locationSearchLogger.debug(`\`${guardName}\` guard is not provided.`);

    return false;
  };
}
